import { Heart } from "lucide-react";

// Langsame, editoriale Laufschrift.
const ITEMS = [
  "Tierschutz",
  "Mit Herz",
  "Erste Hilfe",
  "IgelGemurmel",
  "Igelfreundlicher Garten",
  "Auswilderung",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="relative py-6 md:py-8 bg-brand-green overflow-hidden select-none"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading font-extrabold text-white/90 text-2xl md:text-4xl px-6">
              {item}
            </span>
            <Heart className="w-5 h-5 md:w-6 md:h-6 text-brand-pink" fill="#E06A88" />
          </span>
        ))}
      </div>
    </div>
  );
}
